import { noop } from '@philips-emr/tws-utils';

import FragmentNode from '../core/fragment-node';
import Engine, { FragmentProviderOptions } from '../engine';

import BaseFragment, { BaseFragmentProps, BaseFragmentState } from './base-fragment';

interface SubmittableFragmentProps extends BaseFragmentProps {
  onSubmit: (event: Record<string, any>) => void;
}

class SubmittableFragment extends BaseFragment<SubmittableFragmentProps, BaseFragmentState> {
  state = {
    content: null,
    contextData: {},
    loaded: false,
    node: null,
  };

  unlistenSubmittableFragmentContext: Function = noop;

  componentWillUnmount(): void {
    if (this.props.disposable) {
      this.unlistenSubmittableFragmentContext();
    }
  
    super.componentWillUnmount();
  }

  provideFragment(engine: Engine, options: FragmentProviderOptions): FragmentNode {
    const { onSubmit } = this.props;

    const node = engine.provideFragment({ ...options, submittable: true });

    const submittableFragmentContext = node.getSubmittableFragmentContext();

    this.unlistenSubmittableFragmentContext();
    this.unlistenSubmittableFragmentContext = submittableFragmentContext ? submittableFragmentContext.addListener(onSubmit) : noop;

    return node;
  }
}

export default SubmittableFragment;
